import { apiSlice } from '../../app/api/apiSlice';
import { UpdateClientBody, UpdateSpecialProductBody } from './clientRequestBody';
import { ClientResponse, ClientData, GetClientsResponse, GetNewPINResponse, ClientInfoResponse, ClientInfoData, GetClientChapelAndRemainingQtyResponse, ClientChapelAndReamingQtyData, GetClientActiveBaseOnChapelAndDateToDayResponse, GetClientActiveBaseOnChapelAndDateToDayData } from './clientResponse';

export const clientApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getClient: builder.query<ClientData[], void>({
            query: () => '/api/clients',
            transformResponse: (response: GetClientsResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Client', id: 'LIST' }],
        }),

        getClientById: builder.query<ClientInfoData, number>({
            query: (clientId) => `/api/clients/${clientId}`,
            transformResponse: (response: ClientInfoResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (_result, _error, clientId) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
            ],
        }),

        createClient:  builder.mutation<ClientResponse, any>({
            query: (body) => ({
                url: '/api/clients/register', 
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'Client', id: 'LIST' }],
        }),

        updateClientInfo: builder.mutation<ClientResponse, { clientId: number; body: UpdateClientBody; }>({
            query: ({ clientId, body }) => ({
                url: `/api/clients/${clientId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { clientId }) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
                { type: 'ClientProduct', id: 'LIST' },
                { type: 'ClientProduct', id: clientId },
            ],
        }),

        getClientChapelAndRemainingQty: builder.query<ClientChapelAndReamingQtyData, number>({
            query: (clientId) => `/api/clients/${clientId}/chapel-remaining`,
            transformResponse: (response: GetClientChapelAndRemainingQtyResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (_result, _error, clientId) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
                { type: 'ClientProduct', id: 'LIST' },
                { type: 'ClientProduct', id: clientId },
            ],
        }),
        
        getActiveClientBaseOnChapelAndDateToDay: builder.query<GetClientActiveBaseOnChapelAndDateToDayData[], number>({
            query: (chapelID) => `/api/clients/active/${chapelID}`,
            transformResponse: (response: GetClientActiveBaseOnChapelAndDateToDayResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Client', id: 'LIST' }],
        }),

        deleteClient: builder.mutation<ClientResponse, { clientID: number }>({
            query: ({ clientID }) => ({
                url: `/api/clients/${clientID}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Client', id: 'LIST' }],
        }),

        generateNewPIN: builder.mutation<GetNewPINResponse, number>({
            query: (clientId) => ({
                url: `/api/clients/${clientId}/generatePin`,
                method: 'POST',
            }),
            invalidatesTags: (_result, _error, clientId) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
            ],
        }),
        
        updateClientSpecialPackage: builder.mutation<ClientResponse, { clientId: number; body: UpdateSpecialProductBody }>({
            query: ({ clientId, body }) => ({
                url: `/api/clients/${clientId}/special-package`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (_result, _error, { clientId }) => [
                { type: 'Client', id: clientId },
                { type: 'Client', id: 'LIST' },
                { type: 'ClientProduct', id: 'LIST' },
                { type: 'ClientProduct', id: clientId },
            ],
        }),
    }),
});

export const {
    useGetClientQuery,
    useGetClientByIdQuery,
    useCreateClientMutation,
    useUpdateClientInfoMutation,
    useGetClientChapelAndRemainingQtyQuery,
    useGetActiveClientBaseOnChapelAndDateToDayQuery,
    useDeleteClientMutation,
    useGenerateNewPINMutation,
    useUpdateClientSpecialPackageMutation,
} = clientApiSlice;